import { render, staticRenderFns } from "./sxkxj.vue?vue&type=template&id=d090a0d6&scoped=true"
import script from "./sxkxj.vue?vue&type=script&lang=js"
export * from "./sxkxj.vue?vue&type=script&lang=js"
import style0 from "./sxkxj.vue?vue&type=style&index=0&id=d090a0d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d090a0d6",
  null
  
)

export default component.exports